export const sendEmail = (subject, template, parameters, email) => {
  // Send email to admin

  fetch('/.netlify/functions/sendEmail', {
    method: 'POST',
    body: JSON.stringify({
      email: email,
      subject: `${subject} - GreenCode`,
      template: template,
      parameters: parameters,
    }),
  });
};
